import { IGalleryDesign } from '@topshots/core-models';

export const DEFAULT_GALLERY_DESIGN: IGalleryDesign = {
  backgroundColour: '#000000',
  highlightColour: '#82bd5e',
  textColour: '#ffffff',
  secondaryTextColour: '#999999',
  tertiaryTextColour: '#565656',
  highlightTextColour: '#003407',
  navBackgroundColour: '#000000',
  modalBackgroundColour: '#1d1d1d',
  secondaryButtonColour: '#000000',
  secondaryButtonBorderColour: '#ffffff',
  secondaryButtonTextColour: '#ffffff',
  tertiaryButtonColour: '#b3b3b3',
  tertiaryButtonBorderColour: '#003407',
  tertiaryButtonTextColour: '#003407',
  inputBackgroundColour: '#ffffff',
  inputBorderColour: '#404040',
  inputTextColour: '#000000',
  font: "'Helvetica Neue', Helvetica, Roboto, Arial, sans-serif",
};

export const DEFAULT_GALLERY_DESIGN_LIGHT: IGalleryDesign = {
  backgroundColour: '#ffffff',
  highlightColour: '#82bd5e',
  textColour: '#000000',
  secondaryTextColour: '#666666',
  tertiaryTextColour: '#999999',
  highlightTextColour: '#003407',
  navBackgroundColour: '#ffffff',
  modalBackgroundColour: '#f5f5f5',
  secondaryButtonColour: '#ffffff',
  secondaryButtonBorderColour: '#000000',
  secondaryButtonTextColour: '#000000',
  tertiaryButtonColour: '#e0e0e0',
  tertiaryButtonBorderColour: '#003407',
  tertiaryButtonTextColour: '#003407',
  inputBackgroundColour: '#ffffff',
  inputBorderColour: '#cccccc',
  inputTextColour: '#000000',
  font: "'Helvetica Neue', Helvetica, Roboto, Arial, sans-serif",
};
